import React from "react";
import styled from "styled-components";
import {media} from "assets/css/media";
import arrow from "apps/DRAW_PREDICTOR/assets/images/icons/roundArrow.svg";

const PotSelectField = styled.select`
	font-size: 20px;
	color: #000000;
	border: none;
	text-transform: uppercase;
	background: url(${arrow}) right 10px center no-repeat #eeeee4;
	border-radius: 5px;
	padding: 10px;
	font-family: "Qatar2022", sans-serif;
	width: 100px;
	appearance: none;
	font-weight: 500;

	@media (max-width: ${media.mobile}) {
		padding: 0 5px;
		height: 32px;
		min-width: 100px;
	}
`;

interface IPotSelectProps {
	onChange: (e: React.SyntheticEvent<HTMLSelectElement>) => void;
	disabled?: boolean;
	value: number;
	title: string;
}

export const PotSelect: React.FC<IPotSelectProps> = ({onChange, disabled, value, title}) => (
	<PotSelectField onChange={onChange} disabled={disabled} value={value}>
		<option value={1}>{title} 1</option>
		<option value={2}>{title} 2</option>
		<option value={3}>{title} 3</option>
		<option value={4}>{title} 4</option>
	</PotSelectField>
);
